import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'

export function ErrorPage() {
  const { errorMessage, refresh } = useAuth()

  return (
    <div className="page page-narrow">
      <header className="page-header">
        <h1>エラー</h1>
        <p className="lede">{errorMessage ?? '問題が発生しました。'}</p>
      </header>
      <section className="card actions-row">
        <button type="button" className="btn btn-primary" onClick={() => void refresh()}>
          再試行
        </button>
        <Link to="/login" className="btn btn-ghost">
          ログイン画面へ
        </Link>
      </section>
    </div>
  )
}
